import { PushAnalyticsEventsService } from '@alliance/ats/analytics/utils'
import { NgZoneHelperService, ScrollHelperService } from '@alliance/shared/utils'
import { Component, ChangeDetectionStrategy, ElementRef, AfterViewInit, Inject, OnDestroy } from '@angular/core'
import { StaticTooltipViewHelperService } from '../services/static-tooltip-view-helper.service'
import { BaseStaticTooltipDirective } from '../base-static-tooltip.directive'
import { asyncScheduler, fromEvent, timer } from 'rxjs'
import { DOCUMENT } from '@angular/common'

const TOOLTIP_CONTENT_SELECTOR = 'tooltip-content'
const TOOLTIP_INNER_SELECTOR = 'tooltip-inner'

@Component({
  selector: 'alliance-ats-static-inline-tooltip',
  exportAs: 'staticTooltip',
  templateUrl: './static-inline-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StaticInlineTooltipComponent extends BaseStaticTooltipDirective implements AfterViewInit, OnDestroy {
  public constructor(
    @Inject(DOCUMENT) document: Document,
    ngZoneHelper: NgZoneHelperService,
    staticTooltipViewHelperService: StaticTooltipViewHelperService,
    pushAnalyticsEventsService: PushAnalyticsEventsService,
    private scrollService: ScrollHelperService,
    private elRef: ElementRef<HTMLElement>
  ) {
    super(staticTooltipViewHelperService, document, ngZoneHelper, pushAnalyticsEventsService)

    this.hold(fromEvent(this.elRef.nativeElement, 'click', { capture: true }), (event: Event): void => {
      if (event.target instanceof HTMLElement && event.target.classList.contains(TOOLTIP_CONTENT_SELECTOR)) {
        this.set({ isClickedOutside: true })
        return
      }

      if (event.target instanceof HTMLElement && !event.target.classList.contains(this.get().tooltipSelector)) {
        super.onClicked()
      }
    })
  }

  public override ngAfterViewInit(): void {
    super.ngAfterViewInit()
    const { activeTooltipParentRef } = this.get() ?? {}

    if (!activeTooltipParentRef) {
      return
    }
    this.set({ tooltipSelector: TOOLTIP_INNER_SELECTOR })

    this.hold(timer(10, asyncScheduler), () => {
      const item = this.elRef.nativeElement.querySelector(`#${activeTooltipParentRef}`)
      if (item && item instanceof HTMLElement) {
        const topPosition = item.offsetTop - this.tooltipTopOffsetPosition
        this.scrollService.scrollTo({ topPosition })
      }
    })
  }
}
